import { render } from "./request_verify.vue?vue&type=template&id=01276198"
import script from "./request_verify.vue?vue&type=script&lang=js"
export * from "./request_verify.vue?vue&type=script&lang=js"

import "./request_verify.vue?vue&type=style&index=0&id=01276198&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__